import React, { useLayoutEffect, useRef } from 'react';
import ScrollContainer from '../common/ScrollContainer';
import { Modal, Box, TextareaAutosize, Button, Select, MenuItem } from '@mui/material';

export function PageFooter(props) {
    const self = useRef({}).current;
    const { currentIndex, pagePayload } = props;
    const changePage = props.changePage;

    self.props = props;

    useLayoutEffect(() => {
        initialConstruct.bind(self)('PageFooter', props);
        self.changePage = changePage;
    }, []);

    return (
        <div className="row no-gutters py-3">
            <div className="col d-flex">
                {
                    currentIndex === 0 ? null : <Button className="nav-button ml-auto" variant="contained" style={{ background: "#50A1A4" }}
                        onClick={() => changePage('prev')} >
                        <i className="fa fa-angle-left px-2"></i>Previous</Button>
                }
            </div>
            <div className="col">
                <div className="d-flex" style={{ hight: '100%' }}>
                    {
                        pagePayload.length && <span className="m-auto">{pagePayload[currentIndex].label} / {pagePayload.length}</span>
                    }

                </div>
            </div>
            <div className="col d-flex">
                <Button className="nav-button"
                    variant="contained"
                    style={{ background: "#50A1A4" }}
                    onClick={() => changePage('next')}>
                    {(currentIndex >= pagePayload.length - 1)?'Preview':'Next'}
                    <i className="fa fa-angle-right px-2"></i>
                </Button>
            </div>
        </div>
    )
}

export function PageScroller(props) {
    const self = useRef({}).current;
    const { pagePayload, currentIndex, pagetileref, scrlpagetiles } = props;
    const setPage = props.setPage;

    self.props = props;

    useLayoutEffect(() => {
        initialConstruct.bind(self)('PageScroller', props);
        self.setPage = setPage;
    }, []);

    return (
        <div className='row no-gutters my-5'>
            <div className={"col-12"}>
                <ScrollContainer scrlref={scrlpagetiles} top={10} left={-50} right={-108} shift={108}>
                    {
                        (cprop) => (
                            <div className="page-tiles" ref={scrlpagetiles}>
                                {
                                    pagePayload.map((o, i) => (
                                        <div ref={i == currentIndex ? pagetileref : null} key={i} className={"page-tile " + ((i == currentIndex) && 'active')} onClick={() => setPage(i)}>
                                            <div className='child'></div>
                                            <div className='page_name'>{o.pagename || o.label}</div>
                                        </div>
                                    ))
                                }
                            </div>
                        )
                    }
                </ScrollContainer>
            </div>
        </div>
    )
}

export default PageFooter
